var map = {
	"./FatCatGameStudioBackground.png": "0fba",
	"./FatcatGameStudio.png": "91a8",
	"./FatcatGameStudio2.png": "e785",
	"./GameIcon/Icon.png": "d152",
	"./GameIcon/Icon2.png": "681f",
	"./MemberIcons/AldhairVeraIcon.png": "d368",
	"./MemberIcons/AldhairVeraLogo.png": "c581",
	"./PlatformIcons/appGallery.png": "7a5f",
	"./PlatformIcons/appstore.png": "e308",
	"./PlatformIcons/itch-io.png": "0893",
	"./PlatformIcons/itch-io.svg": "f031",
	"./PlatformIcons/playstore.png": "2e70",
	"./css/main.css": "5aea",
	"./icons/facebook.svg": "8485",
	"./icons/github.svg": "14f6",
	"./icons/google-plus.svg": "2cce",
	"./icons/instagram.svg": "bd6c",
	"./icons/linkedin.svg": "9ed9",
	"./icons/parcel.svg": "9582",
	"./icons/twitter.svg": "acf9",
	"./icons/whatsapp.svg": "7583",
	"./icons/youtube.svg": "11ef"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";